import React, {Component} from 'react'

import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'

import {
  withRouter
} from 'react-router-dom'

import {sair} from '../../actions/auth'

class RCMenuUser extends Component {
    render() {
      return (
        <ul className="pt-menu .modifier pt-elevation-1">
          <li>
            <button className='pt-menu-item pt-icon-log-out pt-popover-dismiss' onClick={() => this.sair()}>
              Sair
            </button>
          </li>
        </ul>
      )
    }

    sair () {
      this.props.sair()
    }
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators({sair}, dispatch)
}

export default withRouter(connect(null, mapDispatchToProps)(RCMenuUser))


// WEBPACK FOOTER //
// ./src/scenes/menu/MenuUser.js